import { Route } from '../ARoute'

export default Route.withPageLayout('ky-hieu-ban-do').addChildren([
  Route.withPath('', 'symbol/index')
    .requireHasAnyInScopes(['style-management'])
    .withName('symbol')
    .withTitle('sidebar.symbol.name'),
  Route.withPath('symbol', 'symbol/icon/icon')
    .requireHasAnyInScopes(['style-management'])
    .withName('symbol-icon')
    .withTitle('sidebar.symbol.name'),
  Route.withPath('fonts', 'symbol/font/index')
    .requireHasAnyInScopes(['style-management'])
    .withName('symbol-font')
    .withTitle('sidebar.font.name'),
  Route.withPath('folder-icon/:id', 'symbol/icon/folderInfo')
    .requireHasAnyInScopes(['style-management'])
    .withName('folderIcon')
    .withTitle('sidebar.symbol.name'),
  Route.withPath('folder-font/:id', 'symbol/font/folderFonts')
    .requireHasAnyInScopes(['style-management'])
    .withName('folderFont')
    .withTitle('sidebar.font.name'),
])
